import gql from 'graphql-tag'

export default gql`
query getHoliday($id: ID!) {
    cashAssist {
        getHoliday(id: $id) {
          id
          date
          day
          name
          cashRegisterId
      }
    }
}`
